import React, { useState, useEffect } from "react";
import JazzHeader from "../homepage_components/JazzHeader";
import JazzHero from "../homepage_components/JazzHero";
import JazzJourney from "../homepage_components/JazzJourney";
import Shop from "../homepage_components/Shop";
import FeaturedAlbums from "../homepage_components/FeaturedAlbums";
import Gallery from "../homepage_components/Gallery";
import UpcomingEvents from "../homepage_components/UpcomingEvents";
import Press from "../homepage_components/Press";
import JazzFooter from "../homepage_components/JazzFooter";
import SplashLoader from "../components/SplashLoader";
import SEO from "../components/SEO";
import { UserHomepageService } from "../services/UserHomepageServices";

export default function HomePage() {
  const [data, setData] = useState({
    discography: [],
    gallery: [],
    events: [],
    quotes: [],
    press: [],
    products: [],
    categories: []
  });
  const [loading, setLoading] = useState(true);
  const [showSplash, setShowSplash] = useState(() => {
    try {
      return !sessionStorage.getItem("splashShown");
    } catch {
      return false;
    }
  });

  const handleCategoryChange = async (categoryId) => {
    try {
      const result = await UserHomepageService.getProductsByCategory(categoryId);
      return result;
    } catch (error) {
      console.error("Failed to filter products by category", error);
      return [];
    }
  };

  useEffect(() => {
    const fetchHomepageData = async () => {
      try {
        const result = await UserHomepageService.getHomepageData();
        setData(result);
      } catch (error) {
        console.error("Failed to fetch homepage data", error);
      } finally {
        setLoading(false);
      }
    };
    fetchHomepageData();
  }, []);

  return (
    <>
      <SEO title="Home" url="/" />
      {showSplash && (
        <SplashLoader
          onFinish={() => {
            setShowSplash(false);
            sessionStorage.setItem("splashShown", "true");
          }}
        />
      )}
      <div className={`min-h-screen bg-white transition-opacity duration-1000 overflow-x-hidden ${showSplash ? 'opacity-0 pointer-events-none select-none' : 'opacity-100'}`}>
        {/* Fixed Header with navigation */}
        <JazzHeader />

        {/* Hero Section - Full viewport with artist name and dynamic image collage */}
        <JazzHero isVisible={!showSplash} />

        {/* Artist Journey Section - Biography with rotated photo cards */}
        <JazzJourney />

        {/* Shop Section - Product cards with add to cart */}
        <Shop 
          initialProducts={data.products} 
          categories={data.categories} 
          onCategoryChange={handleCategoryChange}
          loading={loading} 
        />

        {/* Featured Albums Section - Black background with album grid */}
        <FeaturedAlbums albums={data.discography} loading={loading} />

        {/* Gallery Section - Polaroid-style scattered photo/video display */}
        <Gallery items={data.gallery} loading={loading} />

        {/* Upcoming Events Section - Event listings with date cards */}
        <UpcomingEvents events={data.events} loading={loading} />

        {/* Press Section - Reviews and media coverage */}
        <Press quotes={data.quotes} coverage={data.press} loading={loading} />

        {/* Footer - Links, social media, newsletter */}
        <JazzFooter />
      </div>
    </>
  );
}
